import { useState } from "react";

/*--------------------
* Contact Section
----------------------*/
const CONTACT_EMAIL = "njmorrow14@gmail.com";

export default function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(form.subject || "Hello Twilight Tier");
    const body = encodeURIComponent(
      `${form.message}\n\n— ${form.name}${form.email ? ` (${form.email})` : ""}`
    );
    window.location.href = `mailto:${CONTACT_EMAIL}?subject=${subject}&body=${body}`;
  };

  return (
    <section id="contact" className="section bg-night-900">
      <div className="container">
        <div className="grid lg:grid-cols-12 grid-cols-1 gap-12">
          <div className="lg:col-span-5">
            <p className="eyebrow">04 — Say hello</p>
            <h2 className="text-[32px] md:text-[44px] font-[600] leading-[1.15] mt-4 mb-6">
              Get in touch
            </h2>
            <p className="text-[16px] md:text-[18px] leading-relaxed mb-8">
              Whether you want to collaborate on a venture, pitch a wild idea,
              or just talk shop — the inbox is always open.
            </p>
            <a
              className="font-mono text-[14px] md:text-[15px] text-ember-400 hover:text-ember-300 transition-colors duration-200"
              href={`mailto:${CONTACT_EMAIL}`}
            >
              {CONTACT_EMAIL}
            </a>
          </div>

          <div className="lg:col-span-7">
            <form className="glass-card p-6 md:p-9" onSubmit={handleSubmit}>
              <div className="grid grid-cols-12 gap-5">
                <div className="col-span-12 md:col-span-6">
                  <label className="form-label" htmlFor="name">
                    Name
                  </label>
                  <input
                    name="name"
                    id="name"
                    placeholder="Your name"
                    className="form-control"
                    type="text"
                    value={form.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-span-12 md:col-span-6">
                  <label className="form-label" htmlFor="email">
                    Email
                  </label>
                  <input
                    name="email"
                    id="email"
                    placeholder="you@example.com"
                    className="form-control"
                    type="email"
                    value={form.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-span-12">
                  <label className="form-label" htmlFor="subject">
                    Subject
                  </label>
                  <input
                    name="subject"
                    id="subject"
                    placeholder="What's on your mind?"
                    className="form-control"
                    type="text"
                    value={form.subject}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-span-12">
                  <label className="form-label" htmlFor="message">
                    Message
                  </label>
                  <textarea
                    name="message"
                    id="message"
                    placeholder="Tell us about it…"
                    rows="5"
                    className="form-control"
                    value={form.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>
                <div className="col-span-12">
                  <button className="btn btn-ember" type="submit">
                    Send message
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
